export default "/images/background.jpg?1a50b6751d103fbec745ad5b625ff03f";